import React, { useState } from 'react';

import { EventParticipantType } from './types';

type EventParticipantsProviderProps = {
  children: React.ReactNode;
};

export const EventParticipantsContext = React.createContext<{
  drawerOpened: boolean;
  participantsData: Array<EventParticipantType>;
  setIsDrawerOpened: (isOpened: boolean) => void;
  setParticipants: (participants: Array<EventParticipantType>) => void;
}>({
  drawerOpened: false,
  participantsData: [],
  setIsDrawerOpened: () => {},
  setParticipants: () => {},
});

export const EventParticipantsProvider: React.FC<
  EventParticipantsProviderProps
> = ({ children }) => {
  const [drawerOpened, setDrawerOpened] = useState<boolean>(false);
  const [participantsData, setParticipantsData] = useState<
    Array<EventParticipantType>
  >([]);

  const setIsDrawerOpened = (isOpened: boolean) => {
    setDrawerOpened(isOpened);
  };

  const setParticipants = (participants: Array<EventParticipantType>) => {
    setParticipantsData(participants);
  };

  return (
    <EventParticipantsContext.Provider
      value={{
        drawerOpened,
        setIsDrawerOpened,
        participantsData,
        setParticipants,
      }}
    >
      {children}
    </EventParticipantsContext.Provider>
  );
};

export const useEventParticipantsContext = () =>
  React.useContext(EventParticipantsContext);
